import React, { useEffect, useState, useContext } from 'react';
import { Consumable } from '@/types/database/communityDevice';
import { Image } from 'antd';
import { Dialog } from '@alifd/next';
import moment from 'moment';
import { Box, Typography } from '@mui/material';
import { VendorContext } from '../..';

const RecordDetail: React.FC<{
  record: Consumable | undefined;
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ record, visible, setVisible }) => {
  const [data, setData] = useState<
    {
      label: string;
      value: any;
    }[]
  >([]);
  const vendors = useContext(VendorContext);

  useEffect(() => {
    if (record) {
      setData([
        {
          label: '建立時間',
          value: moment(record.createdTime).format('YYYY-MM-DD'),
        },
        {
          label: '耗材名稱',
          value: record.deviceName,
        },
        {
          label: '耗材編號',
          value: record.deviceNumber ? record.deviceNumber : '無資料',
        },
        {
          label: '保管人',
          value: record.deviceKeeper ? record.deviceKeeper : '無資料',
        },
        {
          label: '保管位置',
          value: record.deviceStorePlace ? record.deviceStorePlace : '無資料',
        },
        {
          label: '購入日期',
          value: moment(record.deviceDate).format('YYYY-MM-DD'),
        },
        {
          label: '耗材年限',
          value: record.deviceYear ? `${record.deviceYear}年` : '無資料',
        },
        {
          label: '耗材價值',
          value: record.deviceMoney ? `${record.deviceMoney}元` : '無資料',
        },
        {
          label: '購買數量',
          value: record.purchaseQuantity
            ? `${record.purchaseQuantity}個`
            : '無資料',
        },
        {
          label: '剩餘數量',
          value: record.remainingQuantity
            ? `${record.remainingQuantity}個`
            : '無資料',
        },
        {
          label: '耗材廠商',
          value:
            vendors.length > 0
              ? vendors
                  .filter((vendor) => vendor._id === record.deviceVendor)
                  .map((vendor) => {
                    return (
                      <p style={{ margin: 0 }} key={vendor._id}>
                        {vendor.name}
                      </p>
                    );
                  })
              : '',
        },
        {
          label: '耗材圖片',
          value:
            (record?.files || []).length > 0 ? (
              <Image
                width={200}
                src={record.files[0].response.showPath}
                alt="圖片"
              />
            ) : (
              '無圖片'
            ),
        },
        {
          label: '耗材規範',
          value:
            (record?.specification || []).length > 0 ? (
              <a
                href={record.specification[0].response.showPath}
                download={record.specification[0].name}
                target="blank"
              >
                {record.specification[0].name}
              </a>
            ) : (
              '無規範'
            ),
        },
      ]);
    }
  }, [record, vendors]);
  return (
    <Dialog
      title="耗材詳細資料"
      visible={visible}
      footer={false}
      onClose={() => setVisible(false)}
    >
      <Box
        sx={{
          height: '600px',
          width: '500px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        {data.length > 0 &&
          data.map((item, index) => (
            <Box key={index}>
              <Typography
                sx={{
                  color: ' rgb(102, 102, 102)',
                  fontSize: '14px',
                  lineHeight: '32px',
                }}
              >
                {item.label}
              </Typography>
              <Box
                sx={{
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                {item.value}
              </Box>
            </Box>
          ))}
      </Box>
    </Dialog>
  );
};

export default RecordDetail;
